module.exports = __webpack_public_path__ + "static/media/usxorhurd.709ed40b.jpg";